/** @format */

import React from 'react';

import {Snackbar as MUISnackbar, IconButton} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

interface Props {
  isSnackbarOpen: boolean;
  handleSnackbarClose: () => void;
  message: React.ReactNode | string;
  vertical?: 'top' | 'bottom';
  horizontal?: 'left' | 'center' | 'right';
}

const Snackbar = (props: Props) => (
  <MUISnackbar
    open={props.isSnackbarOpen}
    autoHideDuration={3000}
    onClose={props.handleSnackbarClose}
    message={props.message}
    anchorOrigin={{
      vertical: props.vertical ?? 'bottom',
      horizontal: props.horizontal ?? 'center',
    }}
    action={
      <IconButton
        size='small'
        aria-label='close'
        color='inherit'
        onClick={props.handleSnackbarClose}
      >
        <CloseIcon fontSize='small' />
      </IconButton>
    }
  />
);

export default Snackbar;
